import React, { useMemo } from "react";

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { channelColumns, getChannelHref } from "./tableParams/channelColumns";
import FastAPI from "../../api/FastAPI";
import CappedPage from "../common/CappedPage";
import DataTable from "../dataTable/DataTable";
import InfoPanel from "../utils/InfoPanel";

import type { JSX } from "react";

const INFO_PANEL_LINKS = {
  en: "https://support.okast.tv/en/support/solutions/103000140849",
  fr: "https://support.okast.tv/fr/support/solutions/103000140849",
};

function FASTChannelList(): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");

  const getChannelsListQuery = FastAPI.generateQuery({
    fn: FastAPI.getChannelsList,
    params: [],
  });

  const { isLoading, isError, refetch, data } = useQuery(getChannelsListQuery);

  const columnList = useMemo(() => channelColumns({ t }), [t]);

  return (
    <CappedPage contentClassName="pt-7.5 pb-15">
      <DataTable
        columns={columnList}
        data={data?.data ?? []}
        description={<InfoPanel links={INFO_PANEL_LINKS} />}
        getRowHref={getChannelHref}
        isError={isError}
        isLoading={isLoading}
        onRetry={refetch}
        title={t("fastChannels")}
      />
    </CappedPage>
  );
}

export default FASTChannelList;
